__turbopack_context__.v({
  "backBtn": "_7KhhUa_backBtn",
  "subheader": "_7KhhUa_subheader",
});
